import ko from "knockout";

export default class SalaryAdministrationInfo {
    parent: any;

    bankAccountNumber: KnockoutObservable<string>;
    paymentCycle: KnockoutObservable<string>;
    paymentDates: KnockoutObservable<string>;

    employeeContributionWhk: KnockoutObservable<boolean>;

    holidayAllowancePercentage: KnockoutObservable<number>;
    socialChargesReserve: KnockoutObservable<number>;
    paymentPeriod: KnockoutObservable<string>;

    directPayoutHolidayAllowance: KnockoutObservable<boolean>;
    directPayoutHolidayDays: KnockoutObservable<boolean>;

    pensionFundHorecaCatering: KnockoutObservable<boolean>;
    applicablePensionScheme: KnockoutObservable<string>;

    fixedAllowancesDeductions: KnockoutObservable<string>;
    variableAllowancesDeductions: KnockoutObservable<string>;

    taxAuthorityDecisionWhkNeeded: KnockoutObservable<boolean>;
    journalStructureNeeded: KnockoutObservable<boolean>;
    latestPayslipsNeeded: KnockoutObservable<boolean>;
    leaseCarOverviewNeeded: KnockoutObservable<boolean>;

    constructor(model: any, parent: any) {
        this.parent = parent;

        this.bankAccountNumber = ko.observable(model?.bankAccountNumber || "");
        this.paymentCycle = ko.observable(model?.paymentCycle || "");
        this.paymentDates = ko.observable(model?.paymentDates || "");

        this.employeeContributionWhk = ko.observable(model?.employeeContributionWhk || false);

        this.holidayAllowancePercentage = ko.observable(model?.holidayAllowancePercentage || 0);
        this.socialChargesReserve = ko.observable(model?.socialChargesReserve || 0);
        this.paymentPeriod = ko.observable(model?.paymentPeriod || "");

        this.directPayoutHolidayAllowance = ko.observable(model?.directPayoutHolidayAllowance || false);
        this.directPayoutHolidayDays = ko.observable(model?.directPayoutHolidayDays || false);

        this.pensionFundHorecaCatering = ko.observable(model?.pensionFundHorecaCatering || false);
        this.applicablePensionScheme = ko.observable(model?.applicablePensionScheme || "");

        this.fixedAllowancesDeductions = ko.observable(model?.fixedAllowancesDeductions || "");
        this.variableAllowancesDeductions = ko.observable(model?.variableAllowancesDeductions || "");

        this.taxAuthorityDecisionWhkNeeded = ko.observable(model?.taxAuthorityDecisionWhk || false);
        this.journalStructureNeeded = ko.observable(model?.journalStructure || false);
        this.latestPayslipsNeeded = ko.observable(model?.latestPayslips || false);
        this.leaseCarOverviewNeeded = ko.observable(model?.leaseCarOverview || false);
    }
}

